const STYLES = {
  confirmed: "bg-status-confirmed/10 text-status-confirmed border-status-confirmed/30",
  pending: "bg-status-pending/10 text-status-pending border-status-pending/30",
  checked_in: "bg-status-checked-in/10 text-status-checked-in border-status-checked-in/30",
  checked_out: "bg-muted text-muted-foreground border-border",
  cancelled: "bg-destructive/10 text-destructive border-destructive/30",
  available: "bg-status-confirmed/10 text-status-confirmed border-status-confirmed/30",
  occupied: "bg-status-checked-in/10 text-status-checked-in border-status-checked-in/30",
  cleaning: "bg-status-pending/10 text-status-pending border-status-pending/30",
  maintenance: "bg-destructive/10 text-destructive border-destructive/30",
  paid: "bg-status-confirmed/10 text-status-confirmed border-status-confirmed/30",
  partial: "bg-status-pending/10 text-status-pending border-status-pending/30",
  unpaid: "bg-destructive/10 text-destructive border-destructive/30",
};

const LABELS = { checked_in: "Checked In", checked_out: "Checked Out" };

export function StatusBadge({ status, testId }) {
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium capitalize ${STYLES[status] || STYLES.pending}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
